import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  render() {
    return (
      <div className="categoty_box">
        <NavLink to="/articledetail/3y1iPj" className="fl categoty_box_div">
          <img
            alt=""
            src={require("../../../../images/category/c_0.png")}
          ></img>
          <div className="categoty_box_text">万能选科</div>
        </NavLink>
        <NavLink to="/rank/subject" className="fl categoty_box_div">
          <img
            alt=""
            src={require("../../../../images/category/c_1.png")}
          ></img>
          <div className="categoty_box_text">精选排名</div>
        </NavLink>
        <NavLink to="/articlelist?categoryId=2" className="fl categoty_box_div">
          <img
            alt=""
            src={require("../../../../images/category/c_2.png")}
          ></img>
          <div className="categoty_box_text">浙考百科</div>
        </NavLink>
        <NavLink
          to="/articlelist?categoryId=1&classId=2"
          className="fl categoty_box_div"
        >
          <img
            alt=""
            src={require("../../../../images/category/c_3.png")}
          ></img>
          <div className="categoty_box_text">强基计划</div>
        </NavLink>
        <NavLink
          to="/articlelist?categoryId=1&classId=1"
          className="fl categoty_box_div"
        >
          <img
            alt=""
            src={require("../../../../images/category/c_4.png")}
          ></img>
          <div className="categoty_box_text">三位一体</div>
        </NavLink>
        <div className="clear"></div>
      </div>
    );
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/containers/Home/components/Category/index.js